import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/rias/ls.rias';
import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes';
import 'lazysizes/plugins/respimg/ls.respimg';

import jQuery from 'jquery';
require('jquery.easing');
import transition from "./transition";

jQuery(document).ready(function($){
	transition.init();

	$(window).on('scroll', function(){

		$('.logo').toggleClass('logo--reduce', $(window).scrollTop() > 150);

	});
});



// WEBPACK FOOTER //
// ./src/js/app.js